<template>
  <div class="Wdgt-Auth-Module">
    <TelegramAuth class="Wdgt-Auth-Module__social-btn" />
    <p class="Wdgt-Auth-Module__separator">или Зарегистрироваться с помощью</p>
    <GoogleAuth class="Wdgt-Auth-Module__social-btn" />
    <ButtonSocial class="Wdgt-Auth-Module__social-btn" :text="'Электронная почта'" @click="toOpenSignupForm"/>
    <p class="Wdgt-Auth-Module__help-txt">
      Создавая аккаунт, Вы принимаете
      <router-link class="Wdgt-Auth-Module__help-lnk" :to="{name: PATHS_NAME.RULES.TERMS}" @click="toCloseAllPopups">Условия использования</router-link>
      и
      <router-link class="Wdgt-Auth-Module__help-lnk" :to="{name: PATHS_NAME.RULES.PRIVACY}" @click="toCloseAllPopups">Политику конфиденциальности</router-link>
    </p>
    <p class="Wdgt-Auth-Module__ftr-txt">
      У Вас есть аккаунт? <button class="Wdgt-Auth-Module__lnk" @click="toOpenLoginSection">Войти</button>
    </p>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { PATHS_NAME } from "@shared/routers/consts/pathsName";
  import AUTH_SECTIONS_NAME from '@shared/constants/dropdowns/authSectionsName.js';
  //------------------------------
  import GoogleAuth from '@widgets/Authorization/components/GoogleAuth/GoogleAuth.vue';
  import ButtonSocial from '@shared/UI/Buttons/ButtonSocial/ButtonSocial';
  import TelegramAuth from "@widgets/Authorization/components/TelegramAuth/TelegramAuth2.vue";
  //----------------------------
  const store = useStore();
  //------------------------------
  //Очистить все дропдауны при переходе на страницу
  const toCloseAllPopups = () => {
    store.dispatch('Dropdowns/clearAllDropdowns');
  }
  //Открыть секцию с формой регистрации
  const toOpenSignupForm = () => {
    store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.SIGNUP_FORM);
  }
  //Открыть стартовую секцию регистрации
  const toOpenLoginSection = () => {
    store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.START_LOGIN);
  }
</script>

<style lang="scss">
  @import '../../styles/Wdgt-Auth-Module.scss';
</style>
